<template>
  <div class="vt-video" v-definesize="autoSize">
    <!-- Poster --> 
    <div v-if="!autoplay && !loading" 
      :class="['vt-video__poster lazyload', { 'vt-video__poster--active' : playing }]" 
      :data-bgset="`${this.poster}?mw=800 [(max-width: 767px)] | ${this.poster}?mw=1280`">
      <a v-if="!loading" class="button button--pause" @click="changeStatus">
        <svg>
          <use xlink:href="#icon-play" />
        </svg>
      </a>
    </div>
    <!-- Video -->
    <div v-show="loading" class="nt-loading nt-loading--block">
      <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
    </div>
    <div v-show="!loading" style="height: 100%">
      <div :id="id"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoYoutube',
  props: {
    autoplay: {
      type: Boolean,
      default: true
    },
    poster: {
      type: String,
      default: null,
      required: true
    },
    videoUrl: {
      type: String,
      default: null,
      required: true
    },
    autoSize: {
      type: Boolean
    }
  },
  data() {
    return {
      id: `video-${Math.floor(Math.random() * 100000)}`,
      playing: false,
      player: null,
      loading: true
    }
  },
  watch: {
    playing(isPlaying) {
      if (isPlaying) {
        this.player.playVideo()
      } else {
        this.player.pauseVideo()
      }
    }
  },
  created() {
    window.console.log('Loading Youtube Player.')

    this.$root.$on('changeVideo', payload => {
      if (payload.id === this.id) {
        switch (payload.command) {
          case 'pause':
            if (!this.playing) return

            this.playing = false
            break
          case 'stop':
            if (this.playing) {
              this.player.stopVideo()
              this.playing = false
            }
            // this.player.seekTo(0)
            break
          default:
            window.console.warn(`Command ${payload.command} not found.`)
            break
        }
      }
    })
  },
  mounted() {
    if (!window.YT) return
    setTimeout(() => {
      this.player = new YT.Player(this.id, { // eslint-disable-line
        width: '100%',
        height: '100%',
        videoId: this.videoUrl,
        playerVars: {
          showinfo: 0,
          modestbranding: 1,
          rel: 0
        },
        events: {
          onReady: this.onPlayerReady
        }
      })
    }, 1000)
  },
  methods: {
    changeStatus() {
      this.pushGTM()
      this.playing = !this.playing
    },
    onPlayerReady() {
      if (this.autoplay) {
        this.playing = true
        this.pushGTM()
      }
      this.loading = false
    },
    pushGTM() {
      window.dataLayer.push({
        event: 'video_check_provider',
        video_provider: 'YouTube'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.vt-video {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;

  &__poster {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #f8f8f8;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 99;

    &--active {
      visibility: hidden;
    }
  }
}
</style>
